export const SimulatorIcon = () => (
  <svg width="30" height="21" viewBox="0 0 30 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="30" height="21" rx="4" fill="#126EDA" />
    <path
      d="M18 3.75068C20.1213 3.75068 21.1818 3.75086 21.8408 4.3835C22.4998 5.01614 22.5 6.03455
      22.5 8.071V8.79072C22.5 10.8271 22.4998 11.8456 21.8408 12.4782C21.1818 13.1106 20.1211 13.111
      18 13.111H15.5625V14.8815L19.6777 16.1979C19.9725 16.2923 20.1314 16.5986 20.0332 16.8815C19.9348
      17.1642 19.6169 17.3166 19.3223 17.2224L15 15.8396L10.6777 17.2224C10.3831 17.3166 10.0652 17.1642
      9.9668 16.8815C9.86856 16.5986 10.0275 16.2923 10.3223 16.1979L14.4375 14.8815V13.111H12C9.87893
      13.111 8.81821 13.1106 8.15918 12.4782C7.50018 11.8456 7.5 10.8271 7.5 8.79072V8.071C7.5 6.03455
      7.50017 5.01614 8.15918 4.3835C8.81819 3.75086 9.87868 3.75068 12 3.75068H18ZM11.3994 5.70088C10.7368
      5.70094 10.1993 6.23842 10.1992 6.90107C10.1992 7.56377 10.7367 8.1012 11.3994 8.10127C12.0622 8.10127
      12.5996 7.56382 12.5996 6.90107C12.5996 6.23838 12.0621 5.70088 11.3994 5.70088Z"
      fill="white"
    />
  </svg>
)
